import api from './api';

/**
 * Chama o backend para gerar o PDF da Guia SADT IAMSPE preenchida
 * a partir da requisição já gravada.
 *
 * @param {{ requisicao: object }} payload
 * @returns {Promise<Blob>}
 */
export const gerarGuiaSadtIamspePdf = async ({ requisicao }) => {
  const response = await api.post(
    'guias/sadt/iamspe/pdf',
    { requisicao },
    { responseType: 'blob' }
  );

  return response.data;
};
